<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #faf5f2">
      <v-flex>
        <v-flex shrink style="text-align: right"
          ><v-btn
            dark
            @click="printPage()"
            style="width: 80px; background-color: black"
            ><v-icon>local_printshop</v-icon></v-btn
          ></v-flex
        >
        <!-- Nevigater -->
        <v-layout mb-12 v-if="$route.query.name === 'verify-rf'">
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.go(-1)"
          >
            <span>ตรวจสอบแบบฟอร์ม RF</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3e7662; font-weight: bold; font-size: 24px"
          >
            <span>รายงานแก้ไขเพิ่มเติมโครงร่างการวิจัย</span>
          </v-flex>
        </v-layout>
        <v-layout v-else mb-12>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.go(-1)"
          >
            <span>Post Approve</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3e7662; font-weight: bold; font-size: 24px"
          >
            <span>รายงานแก้ไขเพิ่มเติมโครงร่างการวิจัย</span>
          </v-flex>
        </v-layout>
        <div id="print" style="height: auto">
          <div class="print-form">
            <v-layout>
              <v-flex>
                <v-layout mt-3 style="background-color: #3e7662">
                  <v-flex
                    my-8
                    ml-8
                    style="text-align: left; font-size: 28px; color: white"
                  >
                    <div style="font-weight: bold">
                      แบบรายงานการแก้ไขเพิ่มเติมโครงร่างการวิจัย
                    </div>
                    <div style="font-size: 18px">Amendment Form</div>
                  </v-flex>
                  <v-flex
                    ml-8
                    pt-8
                    pr-8
                    style="
                      text-align: right;
                      font-weight: bold;
                      font-size: 13px;
                      color: white;
                    "
                  >
                    <span>RF12_2563</span>
                  </v-flex>
                </v-layout>

                <!-- blog 1 -->
                <v-card class="mb-12 px-12">
                  <v-layout py-12 pr-12 mr-12>
                    <v-flex>
                      <!-- row 1 -->
                      <v-layout pt-8>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>รหัสโครงร่างการวิจัย</span>
                        </v-flex>
                        <v-flex xs4>
                          <textfield-form
                            readonly
                            :model="form.researchCode"
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>ชื่อผู้วิจัยหลัก</span>
                        </v-flex>
                        <v-flex xs4>
                          <textfield-form
                            readonly
                            :model="form.firstName"
                          ></textfield-form>
                        </v-flex>
                        <v-flex
                          xs2
                          pr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>นามสกุล</span>
                        </v-flex>
                        <v-flex xs4>
                          <textfield-form
                            readonly
                            :model="form.lastName"
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout pb-6>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>ชื่อโครงการวิจัย</span>
                        </v-flex>
                        <v-flex xs10>
                          <textarea-form
                            readonly
                            :model="form.researchName"
                          ></textarea-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- blog 2 -->
                <v-layout mt-3 style="background-color: #3e7662">
                  <v-flex
                    pl-6
                    my-5
                    ml-8
                    style="text-align: left; font-size: 28px; color: white"
                  >
                    <div style="font-weight: bold">
                      SUMMARY OF PROTOCOL AMENDMENT FOR RISK/BENEFIT ASSESSMENT
                    </div>
                    <div style="font-size: 18px">
                      สรุปการปรับการดำเนินการในโครงร่างการวิจัยสำหรับการประเมินประโยชน์และความเสี่ยง
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout
                  pt-12
                  pb-8
                  mb-12
                  style="
                    background-color: white;
                    padding-left: 60px;
                    padding-right: 70px;
                  "
                >
                  <v-flex>
                    <!-- Group 1 -->
                    <v-layout>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>1. การปรับเกณฑ์การคัดเข้า/คัดออก</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex pl-3 style="text-align: left">
                        <v-radio-group readonly v-model="form.hasScreening" row>
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="ใช่"
                            value="0"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="ไม่ใช่"
                            value="1"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout mb-6>
                      <v-flex pl-3 style="text-align: left">
                        <textarea-form
                          readonly
                          :disabled="form.hasScreening === '1'"
                          :background-color="
                            form.hasScreening === '1' ? '#F9F9F9' : '#FBF6F3'
                          "
                          :model="form.screening"
                          placeholder="(อธิบายโดยสรุปและระบุเหตุผล)"
                        ></textarea-form>
                      </v-flex>
                    </v-layout>
                    <!-- Group 2 -->
                    <v-layout>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>2. การปรับวิธีการหรือขนาดยา</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex pl-3 style="text-align: left">
                        <v-radio-group
                          readonly
                          row
                          v-model="form.hasAdjustMethod"
                        >
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="ใช่"
                            value="0"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="ไม่ใช่"
                            value="1"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout mb-6>
                      <v-flex pl-3 style="text-align: left">
                        <textarea-form
                          readonly
                          :disabled="form.hasAdjustMethod === '1'"
                          :background-color="
                            form.hasAdjustMethod === '1' ? '#F9F9F9' : '#FBF6F3'
                          "
                          :model="form.adjustMethod"
                          placeholder="(อธิบายโดยสรุปและระบุเหตุผล)"
                        ></textarea-form>
                      </v-flex>
                    </v-layout>
                    <!-- Group 3 -->
                    <v-layout>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>3. เพิ่มเติมหัตถการในการวิจัย</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex pl-3 style="text-align: left">
                        <v-radio-group
                          readonly
                          row
                          v-model="form.hasAddOperate"
                        >
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="ใช่"
                            value="0"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="ไม่ใช่"
                            value="1"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout mb-6>
                      <v-flex pl-3 style="text-align: left">
                        <textarea-form
                          readonly
                          :disabled="form.hasAddOperate === '1'"
                          :background-color="
                            form.hasAddOperate === '1' ? '#F9F9F9' : '#FBF6F3'
                          "
                          :model="form.addOperate"
                          placeholder="(อธิบายโดยสรุปและระบุเหตุผล)"
                        ></textarea-form>
                      </v-flex>
                    </v-layout>
                    <!-- Group 4 -->
                    <v-layout>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span>4. ขยายระยะเวลาการให้ยาวิจัย</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex pl-3 style="text-align: left">
                        <v-radio-group
                          readonly
                          row
                          v-model="form.hasExpandTime"
                        >
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="ใช่"
                            value="0"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="ไม่ใช่"
                            value="1"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout mb-6>
                      <v-flex pl-3 style="text-align: left">
                        <textarea-form
                          readonly
                          :disabled="form.hasExpandTime === '1'"
                          :background-color="
                            form.hasExpandTime === '1' ? '#F9F9F9' : '#FBF6F3'
                          "
                          :model="form.expandTime"
                          placeholder="(อธิบายโดยสรุปและระบุเหตุผล)"
                        ></textarea-form>
                      </v-flex>
                    </v-layout>
                    <!-- Group 5 -->
                    <v-layout>
                      <v-flex style="text-align: left; font-weight: bold">
                        <span
                          >5.
                          การปรับการดำเนินการวิจัยอื่นๆที่มีผลเพิ่มตามความเสี่ยงต่ออาสาสมัคร</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex pl-3 style="text-align: left">
                        <v-radio-group
                          readonly
                          row
                          v-model="form.hasAdjustOtherMethod"
                        >
                          <v-radio
                            color="#3E7662"
                            style="padding-right: 100px"
                            label="ใช่"
                            value="0"
                          ></v-radio>
                          <v-radio
                            color="#3E7662"
                            label="ไม่ใช่"
                            value="1"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <v-layout mb-6>
                      <v-flex pl-3 style="text-align: left">
                        <textarea-form
                          readonly
                          :disabled="form.hasAdjustOtherMethod === '1'"
                          :background-color="
                            form.hasAdjustOtherMethod === '1'
                              ? '#F9F9F9'
                              : '#FBF6F3'
                          "
                          :model="form.adjustOtherMethod"
                          placeholder="(อธิบายโดยสรุปและระบุเหตุผล)"
                        ></textarea-form>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- Blog 3 -->
                <v-layout
                  pt-12
                  pb-8
                  mb-12
                  style="
                    background-color: white;
                    padding-left: 60px;
                    padding-right: 70px;
                  "
                >
                  <v-flex>
                    <v-layout mb-12>
                      <v-flex style="font-weight: bold" justify-start>
                        <span>CHECK ALL PROTOCOL AMENDMENTS THAT APPLY :</span>
                      </v-flex>
                    </v-layout>
                    <!-- Group 1 -->
                    <v-layout px-12>
                      <v-flex
                        xs6
                        style="
                          text-align: left;
                          font-weight: bold;
                          font-size: 18px;
                        "
                        justify-start
                      >
                        <span>Information sheet / Consent form</span>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      v-for="(item, i) in form.fileInformationSheet"
                      :key="i"
                      px-12
                      my-12
                      class="justify-center"
                    >
                      <v-flex shrink>
                        <span>File :</span>
                      </v-flex>
                      <v-flex xs6 class="text-left">
                        <a
                          :href="item.filePath"
                          style="color: #3e7662"
                          target="_blank"
                        >
                          <span>{{ item.title }}</span>
                        </a>
                      </v-flex>
                      <v-flex shrink>
                        <span>Version :</span>
                      </v-flex>
                      <v-flex xs2 class="text-left">
                        <span>{{ item.version }}</span>
                      </v-flex>
                      <v-flex shrink>
                        <span>Date :</span>
                      </v-flex>
                      <v-flex xs2 class="text-left">
                        <span>{{
                          dynamicDateChange["fileInformationSheet"][i]
                        }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout px-12 pb-12>
                      <v-flex style="text-align: left; color: #544a44">
                        <span
                          >(Provide copy of original consent form, a description
                          of the revisions and highlighted revised consent
                          form)</span
                        >
                      </v-flex>
                    </v-layout>

                    <!-- Group 2 -->
                    <v-layout px-12 mt-8>
                      <v-flex
                        style="
                          text-align: left;
                          font-weight: bold;
                          font-size: 18px;
                        "
                        xs6
                        justify-start
                      >
                        <span>Protocol Modification or Amendment</span>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      v-for="(item, i) in form.fileProtocolModify"
                      :key="i"
                      px-12
                      my-12
                      class="justify-center"
                    >
                      <v-flex shrink>
                        <span>File :</span>
                      </v-flex>
                      <v-flex xs6 class="text-left">
                        <a
                          :href="item.filePath"
                          style="color: #3e7662"
                          target="_blank"
                        >
                          <span>{{ item.title }}</span>
                        </a>
                      </v-flex>
                      <v-flex shrink>
                        <span>Version :</span>
                      </v-flex>
                      <v-flex xs2 class="text-left">
                        <span>{{ item.version }}</span>
                      </v-flex>
                      <v-flex shrink>
                        <span>Date :</span>
                      </v-flex>
                      <v-flex xs2 class="text-left">
                        <span>{{
                          dynamicDateChange["fileProtocolModify"][i]
                        }}</span>
                      </v-flex>
                    </v-layout>
                    <v-layout px-12>
                      <v-flex style="text-align: left; color: #544a44">
                        <span>
                          (Attach a description of the modification, amendment,
                          and addendum, all supporting documents, and a
                          highlighted (tracked changed) revised consent form, if
                          required.)
                        </span>
                      </v-flex>
                    </v-layout>
                    <!-- Group 3 -->
                    <v-layout mt-12 style="padding-left: 150px">
                      <v-flex>
                        <!-- row 1 -->
                        <v-layout>
                          <v-flex
                            :class="
                              !form.inclusion ? '' : 'color-label-checkbox'
                            "
                          >
                            <v-checkbox
                              readonly
                              v-model="form.inclusion"
                              hide-details
                              color="#3E7662"
                              label="Inclusion / Exclusion Criteria Change"
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <!-- row 2 -->
                        <v-layout>
                          <v-flex
                            :class="
                              !form.procedureChange
                                ? ''
                                : 'color-label-checkbox'
                            "
                          >
                            <v-checkbox
                              readonly
                              v-model="form.procedureChange"
                              hide-details
                              color="#3E7662"
                              label="Procedure Changes"
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <!-- row 3 -->
                        <v-layout>
                          <v-flex
                            :class="
                              !form.editorial ? '' : 'color-label-checkbox'
                            "
                          >
                            <v-checkbox
                              readonly
                              v-model="form.editorial"
                              hide-details
                              color="#3E7662"
                              label="Editorial / Administrative Changes"
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <!-- row 3 -->
                        <v-layout>
                          <v-flex
                            shrink
                            :class="
                              !form.hasOtherChange ? '' : 'color-label-checkbox'
                            "
                          >
                            <v-checkbox
                              readonly
                              hide-details
                              color="#3E7662"
                              v-model="form.hasOtherChange"
                              label="Other changes, please specify"
                              @change="otherChangeCheckbox()"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex ml-4 pt-1>
                            <textfield-form-append
                              readonly
                              :disabled="!form.hasOtherChange"
                              :model="form.otherChange"
                            ></textfield-form-append>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <!-- Group 4-->
                    <v-layout px-12 mt-8>
                      <!-- row 1-->
                      <v-flex
                        xs6
                        style="
                          text-align: left;
                          font-weight: bold;
                          font-size: 18px;
                        "
                        justify-start
                      >
                        <span>Investigator Brochure</span>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      v-for="(item, i) in form.fileInvestigator"
                      :key="i"
                      px-12
                      my-12
                      class="justify-center"
                    >
                      <v-flex shrink>
                        <span>File :</span>
                      </v-flex>
                      <v-flex xs6 class="text-left">
                        <a
                          :href="item.filePath"
                          style="color: #3e7662"
                          target="_blank"
                        >
                          <span>{{ item.title }}</span>
                        </a>
                      </v-flex>
                      <v-flex shrink>
                        <span>Version :</span>
                      </v-flex>
                      <v-flex xs2 class="text-left">
                        <span>{{ item.version }}</span>
                      </v-flex>
                      <v-flex shrink>
                        <span>Date :</span>
                      </v-flex>
                      <v-flex xs2 class="text-left">
                        <span>{{
                          dynamicDateChange["fileInvestigator"][i]
                        }}</span>
                      </v-flex>
                    </v-layout>
                    <!-- row 2-->
                    <v-layout px-12>
                      <v-flex
                        xs6
                        :class="
                          !form.hasNewInformation ? '' : 'color-label-checkbox'
                        "
                        style="font-weight: bold; font-size: 18px"
                        justify-start
                      >
                        <v-checkbox
                          readonly
                          v-model="form.hasNewInformation"
                          hide-details
                          color="#3E7662"
                          label="New Information Provided to Subjects"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                    <!-- row 3-->
                    <v-layout px-12>
                      <v-flex
                        xs6
                        :class="
                          !form.hasAdvertisement ? '' : 'color-label-checkbox'
                        "
                        style="font-weight: bold; font-size: 18px"
                        justify-start
                      >
                        <v-checkbox
                          readonly
                          v-model="form.hasAdvertisement"
                          hide-details
                          color="#3E7662"
                          label="Advertisement (s) / Recruitment Letter (s)"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                    <v-layout px-12 my-3>
                      <v-flex class="text-left" style="font-weight: bold">
                        <span>ไฟล์อื่นๆ</span>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      v-for="(item, i) in form.fileOther"
                      :key="i"
                      px-12
                      my-12
                      class="justify-center"
                    >
                      <v-flex shrink>
                        <span>File :</span>
                      </v-flex>
                      <v-flex xs6 class="text-left">
                        <a
                          :href="item.filePath"
                          style="color: #3e7662"
                          target="_blank"
                        >
                          <span>{{ item.title }}</span>
                        </a>
                      </v-flex>
                      <v-flex shrink>
                        <span>Version :</span>
                      </v-flex>
                      <v-flex xs2 class="text-left">
                        <span>{{ item.version }}</span>
                      </v-flex>
                      <v-flex shrink>
                        <span>Date :</span>
                      </v-flex>
                      <v-flex xs2 class="text-left">
                        <span>{{ dynamicDateChange["fileOther"][i] }}</span>
                      </v-flex>
                    </v-layout>
                    <!-- row 4-->
                    <v-layout px-12 mb-6>
                      <v-flex
                        shrink
                        :class="
                          !form.hasChangeInTitle ? '' : 'color-label-checkbox'
                        "
                        style="width: 180px; font-weight: bold; font-size: 18px"
                        justify-start
                      >
                        <v-checkbox
                          readonly
                          v-model="form.hasChangeInTitle"
                          hide-details
                          color="#3E7662"
                          label="Change in Title :"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex
                        pt-1
                        style="
                          text-align: left;
                          font-weight: bold;
                          font-size: 16px;
                          color: #3e7662;
                        "
                      >
                        <span
                          >(Attach revised consent form with new title)</span
                        >
                      </v-flex>
                    </v-layout>
                    <!-- Title form area -->
                    <v-layout
                      mt-8
                      mb-4
                      style="text-align: left; padding-left: 80px"
                    >
                      <v-flex justify-start>
                        <span
                          style="font-size: 24px; font-weight: bold"
                          :style="[
                            !form.hasChangeInTitle
                              ? { color: 'gray' }
                              : { color: '#000' },
                          ]"
                        >
                          New Title :
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout px-12>
                      <v-flex>
                        <textarea-form
                          readonly
                          :model="form.changeInTitle"
                          :disabled="!form.hasChangeInTitle"
                          :rows="10"
                          :background-color="
                            !form.hasChangeInTitle ? '#F9F9F9' : '#FBF6F3'
                          "
                        ></textarea-form>
                      </v-flex>
                    </v-layout>
                    <!-- Group 5 -->
                    <v-layout px-12>
                      <v-flex
                        :class="
                          !form.hasChangeInInvestigator
                            ? ''
                            : 'color-label-checkbox'
                        "
                        justify-start
                        style="font-size: 18px; font-weight: bold"
                      >
                        <v-checkbox
                          readonly
                          v-model="form.hasChangeInInvestigator"
                          hide-details
                          color="#3E7662"
                          label="Change in Investigators :"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                    <v-layout px-12 mt-2>
                      <v-flex style="text-align: left; color: #544a44">
                        <span>
                          (Attach revised consent form., Include CV, ethical
                          training records, and letter from Sponsor
                          acknowledging change, if applicable)
                        </span>
                      </v-flex>
                    </v-layout>
                    <!-- text field append form  -->
                    <v-layout px-12 mt-3>
                      <v-flex mr-6>
                        <textfield-form-append
                          readonly
                          css="font-weight: bold"
                          :disabled="!form.hasChangeInInvestigator"
                          :model="form.changeInInvestigatorAdd"
                          label="Add Name : "
                        ></textfield-form-append>
                      </v-flex>
                      <v-flex>
                        <textfield-form-append
                          readonly
                          css="font-weight: bold"
                          :disabled="!form.hasChangeInInvestigator"
                          :model="form.changeInInvestigatorDelete"
                          label="Delete Name : "
                        ></textfield-form-append>
                      </v-flex>
                    </v-layout>
                    <!-- Group 6 -->
                    <v-layout px-12 mt-6>
                      <v-flex
                        :class="
                          !form.hasChangeInSponsor ? '' : 'color-label-checkbox'
                        "
                        justify-start
                        style="font-size: 18px; font-weight: bold"
                      >
                        <v-checkbox
                          readonly
                          v-model="form.hasChangeInSponsor"
                          hide-details
                          color="#3E7662"
                          label="Change in Sponsor(s) :"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                    <!-- text field append form  -->
                    <v-layout px-12 mt-3>
                      <v-flex mr-6>
                        <textfield-form-append
                          readonly
                          :disabled="!form.hasChangeInSponsor"
                          css="font-weight: bold"
                          :model="form.changeInSponsorAdd"
                          label="Add Sponsor Name : "
                        ></textfield-form-append>
                      </v-flex>
                      <v-flex>
                        <textfield-form-append
                          readonly
                          :disabled="!form.hasChangeInSponsor"
                          css="font-weight: bold"
                          :model="form.changeInSponsorDelete"
                          label="Delete Sponsor Name : "
                        ></textfield-form-append>
                      </v-flex>
                    </v-layout>
                    <!-- Group 7 -->
                    <v-layout mt-12 px-12>
                      <v-flex>
                        <v-layout>
                          <v-flex xs6 pl-3 mr-6>
                            <textfield-form-append
                              readonly
                              :model="form.signature"
                              hide-detail
                              icon="edit"
                            ></textfield-form-append>
                          </v-flex>
                          <v-flex>
                            <v-layout justify-center>
                              <v-flex
                                shrink
                                mr-4
                                pt-2
                                style="text-align: right; font-weight: bold"
                              >
                                <span>Date</span>
                              </v-flex>
                              <v-flex>
                                <textfield-form
                                  readonly
                                  :model="form.reportDate"
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                            <!--                                                <DateInputForm-->
                            <!--                                                        :model="date"-->
                            <!--                                                        label="Date"-->
                            <!--                                                ></DateInputForm>-->
                          </v-flex>
                        </v-layout>
                        <v-layout
                          px-12
                          style="margin-top: -20px; font-weight: bold"
                        >
                          <v-flex xs6>
                            <span>Signature of Principal Investigator</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout mt-12>
                      <v-flex style="font-weight: bold" justify-start>
                        <span
                          >สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span
                        >
                      </v-flex>
                      <v-flex style="font-weight: bold" justify-end>
                        <span>หน้า 1 จาก 1 หน้า</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- Blog 4 -->
                <v-layout mt-3 style="background-color: #3e7662">
                  <v-flex
                    my-8
                    ml-8
                    style="
                      text-align: left;
                      font-weight: bold;
                      font-size: 28px;
                      color: white;
                    "
                  >
                    <div>แบบรายงานการแก้ไขเพิ่มเติมโครงร่างการวิจัย</div>
                    <div style="font-size: 18px">Amendment Form</div>
                  </v-flex>
                </v-layout>
                <v-card class="mb-12 px-12">
                  <v-layout py-12>
                    <v-flex>
                      <!-- row 1 -->
                      <v-layout justify-center>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>ชื่อโครงการวิจัย</span>
                        </v-flex>
                        <v-flex xs6>
                          <textarea-form
                            readonly
                            :model="form.researchName2"
                          ></textarea-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout justify-center>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>ผู้วิจัย</span>
                        </v-flex>
                        <v-flex xs6>
                          <textfield-form
                            readonly
                            :model="form.researcher"
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout justify-center>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>เบอร์โทรศัพท์</span>
                        </v-flex>
                        <v-flex xs6>
                          <textfield-form
                            readonly
                            :model="form.phoneNumber"
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 4 -->
                      <v-layout justify-center>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>สังกัด</span>
                        </v-flex>
                        <v-flex xs6>
                          <textfield-form
                            readonly
                            :model="form.affiliation"
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!-- Blog 6 -->
                <v-card></v-card>
                <v-layout pb-12>
                  <v-flex>
                    <!-- Table 2 -->
                    <v-layout py-4 style="background-color: #3e7662">
                      <v-flex>
                        <span style="color: white; font-size: 24px"
                          >แบบฟอร์มการแก้ไข RF12</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex>
                        <v-divider
                          style="background-color: #544a44; border-width: 2px"
                        ></v-divider>
                      </v-flex>
                    </v-layout>

                    <!-- Table -->
                    <v-layout>
                      <v-flex class="table">
                        <v-data-table
                          :headers="researchAllHeaders"
                          :items="itemTableEdit"
                          hide-default-footer
                        >
                          <template v-slot:item.file="{ item }">
                            <a
                              v-if="item.file"
                              :href="item.file"
                              target="_blank"
                              style="text-decoration: none"
                            >
                              <v-icon color="#3E7662" style="cursor: pointer"
                                >visibility</v-icon
                              >
                            </a>
                            <v-icon v-if="!item.file" color="grey"
                              >visibility</v-icon
                            >
                          </template>
                          <template v-slot:item.delete="{ item }">
                            <v-icon
                              color="#FF0000"
                              @click="deleteRowTableEdit(item)"
                              style="cursor: pointer"
                              >delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>

                    <v-layout>
                      <v-flex>
                        <v-divider
                          style="background-color: #544a44; border-width: 2px"
                        ></v-divider>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- Blog 7 -->
                <v-layout
                  pt-12
                  pb-8
                  mb-8
                  style="
                    background-color: white;
                    padding-left: 60px;
                    padding-right: 70px;
                  "
                >
                  <v-flex>
                    <v-layout class="my-12">
                      <v-flex>
                        <v-layout class="mb-8">
                          <v-flex>
                            <v-layout>
                              <v-flex shrink pr-4 style="text-align: left">
                                <span style="font-weight: bold; font-size: 16px"
                                  >หนังสือของหน่วยงาน :</span
                                >
                              </v-flex>
                              <v-flex shrink>
                                <span
                                  class="text-start linkPDF"
                                  style="font-size: 16px; color: #cc3d45"
                                  @click="open"
                                >
                                  {{ agencyBook }}
                                </span>
                              </v-flex>
                              <v-spacer></v-spacer>
                            </v-layout>
                          </v-flex>
                        </v-layout>

                        <v-layout>
                          <v-flex xs6>
                            <v-layout>
                              <v-flex
                                class="align-center mr-4 font-weight-bold"
                                shrink
                                >เลขหนังสือ
                              </v-flex>
                              <v-flex>
                                <textfield-form
                                  hide-detail
                                  :model="form.bookNumber"
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs6>
                            <v-layout>
                              <v-flex
                                class="align-center mx-4 font-weight-bold"
                                shrink
                                >วันที่หนังสือ
                              </v-flex>
                              <v-flex>
                                <textfield-form
                                  hide-detail
                                  readonly
                                  :model="form.bookDate"
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                      <v-flex xs6 mt-5>
                        <v-layout>
                          <v-flex class="d-flex align-center mr-4 font-weight-bold" shrink>หน่วยงานที่ออกหนังสือ</v-flex>
                          <v-flex>
                            <textfield-form hide-detail :model="form.instituteBook"
                              @update-data="updateData('instituteBook', $event)"></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                      </v-flex>
                    </v-layout>

                    <v-layout justify-space-between>
                      <v-flex xs5 pl-3 mr-6>
                        <textfield-form-append
                          readonly
                          :model="form.researcherSignature"
                          css="font-weight: bold;"
                          label="ผู้วิจัย"
                          hide-detail
                        ></textfield-form-append>
                      </v-flex>
                      <v-flex xs5>
                        <v-layout justify-center>
                          <v-flex
                            shrink
                            mr-4
                            pt-2
                            style="text-align: right; font-weight: bold"
                          >
                            <span>วันที่รายงาน</span>
                          </v-flex>
                          <v-flex>
                            <textfield-form
                              readonly
                              :model="form.reportDate"
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout style="margin-top: 30px">
                      <v-flex
                        ml-8
                        my-5
                        style="text-align: left; font-weight: bold"
                      >
                        <span>Note</span>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex style="padding-left: 32px; padding-right: 32px">
                        <textarea-form
                          @update-data="updateData('noteDetail', $event)"
                          :model="form.noteDetail"
                          :rows="5"
                        ></textarea-form>
                      </v-flex>
                    </v-layout>
                    <v-layout style="margin-top: -35px">
                      <v-flex
                        ml-8
                        my-5
                        style="text-align: left; font-weight: bold"
                      >
                        <span>การตรวจสอบ</span>
                      </v-flex>
                    </v-layout>
                    <v-layout style="margin-left: 32px; margin-top: -15px">
                      <span style="font-weight: bold; padding-top: 19px"
                        >วันที่ผู้วิจัยรายงาน</span
                      >
                      <v-col cols="2" class="text-end text-field-center">
                        <DateInputForm
                          :model="researcherReportDate"
                          @update-data="
                            updateData('researcherReportDate', $event)
                          "
                          style="font-weight: bold"
                        ></DateInputForm>
                      </v-col>
                    </v-layout>
                    <v-layout mt-8>
                      <v-flex style="font-weight: bold" justify-start>
                        <span
                          >สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span
                        >
                      </v-flex>
                      <v-flex style="font-weight: bold" justify-end>
                        <span>หน้า 1 จาก 1 หน้า</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <v-layout mt-8>
          <v-flex mb-12 style="text-align: left">
            <v-layout>
              <v-flex>
                <v-btn
                  style="color: #3e7662"
                  class="mx-4"
                  depressed
                  color="#ffffff"
                  @click="$router.go(-1)"
                  >ย้อนกลับ</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex mb-12 style="text-align: right">
            <v-layout>
              <v-flex>
                <v-btn
                  v-if="status == 'รอดำเนินการ'"
                  style="color: #3e7662"
                  class="mx-4"
                  depressed
                  color="#ffffff"
                  @click="saveEdit()"
                  ><v-icon>add</v-icon>บันทึกเพื่อแก้ไข</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-pageAndLine="fullpageAndLine"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../../components/input/TextfieldForm";
import DateInputForm from "../../../components/input/DateInputForm";
import TextareaForm from "../../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../../components/input/TextfieldFormAppend";
import DateInputFormAppend from "../../../components/input/DateInputFormAppend";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";

export default {
  name: "ViewFormRF12",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
    DateInputFormAppend,
    // editAdd,
  },
  computed: {
    ...mapState({
      researchID: (state) => state.formRF.researchID,
    }),
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    isLoading: false,
    fullpageAndLine: true,
    selected: [],
    dialog: false,
    agencyBookLink: "",
    form: {
      noteDetail: "",
      researcherReportDate: "",
      // blog 1
      researchCode: "",
      firstName: "",
      lastName: "",
      researchName: "",
      // blog 2
      hasScreening: "1",
      screening: "",
      hasAdjustMethod: "1",
      adjustMethod: "",
      hasAddOperate: "1",
      addOperate: "",
      hasExpandTime: "1",
      expandTime: "",
      hasAdjustOtherMethod: "1",
      adjustOtherMethod: "",
      fileInformationSheet: "",
      fileProtocolModify: "",
      fileInvestigator: "",
      fileOther: [],
      inclusion: false,
      procedureChange: false,
      editorial: false,
      hasOtherChange: false,
      otherChange: "",
      hasNewInformation: false,
      hasAdvertisement: false,
      hasChangeInTitle: false,
      changeInTitle: "",
      hasChangeInInvestigator: false,
      changeInInvestigatorAdd: "",
      changeInInvestigatorDelete: "",
      hasChangeInSponsor: false,
      changeInSponsorAdd: "",
      changeInSponsorDelete: "",
      signature: "",
      date: "",
      // blog 4
      researchName2: "",
      researcher: "",
      phoneNumber: "",
      affiliation: "",
      // blog 7
      agencyBook: "",
      bookNumber: "",
      bookDate: "",
      instituteBook:"",
      researcherSignature: "",
      reportDate: "",
    },
    status: "",
    researcherReportDate: "",
    agencyBook: "",
    fileInformationSheetPath: "",
    fileProtocolModifyPath: "",
    fileInvestigatorPath: "",
    researchAllHeaders: [
      { text: "Version", value: "version", align: "center" },
      { text: "หน้า / บรรทัด", value: "pageAndLine", align: "center" },
      { text: "ข้อมูลเดิม / ข้อเสนอแนะ", value: "suggestion", align: "center" },
      { text: "ดูไฟล์", value: "file", align: "center" },
      // { text: 'ลบ', value: 'delete', align: "center" },
    ],
    itemResearchAll: [],
    itemTableEdit: [],
    edit: {
      version: "",
      pageAndLine: "",
      suggestion: "",
      file: "",
    },
    information: {
      version: "",
      pageAndLine: "",
      suggestion: "",
      file: "",
    },
    userID: "",

    date: "",
    reportDate: "",
    dynamicDateChange: {
      fileInformationSheet: [],
      fileProtocolModify: [],
      fileInvestigator: [],
      fileOther: [],
    },
  }),
  created() {
    this.getRF12(this.$route.query.rfID);
  },
  methods: {
    async printPage() {
      this.printMode = true;
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
        "#fff";
      await document.querySelectorAll("button").forEach(function (element) {
        element.style.display = "none";
      });
      await document.querySelectorAll(".v-icon").forEach(function (element) {
        element.style.display = "none";
      });
      await document
        .getElementsByClassName("v-input--checkbox v-input--is-label-active")
        .forEach(function (element) {
          element.innerHTML = "✓" + element.innerHTML;
        });
      await document
        .getElementsByClassName("v-radio v-item--active")
        .forEach(function (element) {
          element.innerHTML = "✓ " + element.innerHTML;
        });
      var node = document.getElementById("print");
      var self = this;
      domtoimage
        .toPng(node)
        .then(async function (dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          var page = self.imageToPrint(img);

          var pageLink = "about:blank";
          var pwa = window.open(pageLink, "_new");
          pwa.document.open();
          pwa.document.write(page);
          pwa.document.close();
          self.printMode = false;
          await document.querySelectorAll("button").forEach(function (element) {
            element.style.display = "unset";
          });
          await document
            .getElementsByClassName(
              "v-input--checkbox v-input--is-label-active"
            )
            .forEach(function (element) {
              element.innerHTML = element.innerHTML.replace("✓", "");
            });
          await document
            .getElementsByClassName("v-radio v-item--active")
            .forEach(function (element) {
              element.innerHTML = element.innerHTML.replace("✓ ", "");
            });
          await document
            .querySelectorAll(".v-icon")
            .forEach(function (element) {
              element.style.display = "unset";
            });
          document
            .getElementsByClassName("print-form")[0]
            .removeAttribute("style");
        })
        .catch(function (error) {
          Swal.fire({
            title: "กรุณาเปิดการอนุญาต Pop Up!",
            description: "",
            icon: "error",
            confirmButtonColor: "#3E7662",
            cancelButtonColor: "rgb(189, 189, 189)",
            confirmButtonText: "ตกลง",
          }).then(async function () {
            await document
              .querySelectorAll("button")
              .forEach(function (element) {
                element.style.display = "unset";
              });
            await document
              .getElementsByClassName(
                "v-input--checkbox v-input--is-label-active"
              )
              .forEach(function (element) {
                element.innerHTML = element.innerHTML.replace("✓", "");
              });
            await document
              .getElementsByClassName("v-radio v-item--active")
              .forEach(function (element) {
                element.innerHTML = element.innerHTML.replace("✓ ", "");
              });
            await document
              .querySelectorAll(".v-icon")
              .forEach(function (element) {
                element.style.display = "unset";
              });
            document
              .getElementsByClassName("print-form")[0]
              .removeAttribute("style");
          });
        });
    },
    imageToPrint(source) {
      return (
        "<html><body onload='window.print()'><style>@media print {\n" +
        "  @page { margin: 0; }\n" +
        "  html, body {\n" +
        "    margin: 0;\n" +
        "    width: 210mm;\n" +
        "    height: 297mm;\n" +
        "  }\n" +
        "  img {\n" +
        "    margin-top: 10mm;\n" +
        "    margin-left: 20mm;\n" +
        "    width: 170mm;\n" +
        // "    height: 297mm;\n" +
        "  }\n" +
        "}</style>" +
        source.outerHTML +
        "</body></html>"
      );
    },
    saveEdit() {
      Swal.fire({
        title: "คุณต้องการบันทึกเพื่อแก้ไขหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึกเพื่อแก้ไข",
      }).then((result) => {
        if (result.value) {
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;

          this.isLoading = true;
          this.$store
            .dispatch("FormRF/saveEditRF12", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกเพื่อแก้ไขสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.push("/verify-rf");
              });
              console.log("res", res);

              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
            });
        }
      });
    },
    updateData(name, val) {
      if (name === "researcherReportDate") {
        console.log("date rf12",val);
        this.researcherReportDate = this.changeDate(val.date);
        this.form.researcherReportDate = val.date;
      }
      if (name === "noteDetail") {
        this.form.noteDetail = val;
      }
    },
    open() {
      window.open(this.agencyBookLink);
    },
    changeDate(val) {
      if (val != null) {
        //change date start
        let sub_year = val.substring(0, 4);
        let sub_month = val.substring(5, 7);
        let sub_day = val.substring(8, 10);
        sub_year = parseInt(sub_year) + 543;
        let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
        return changeDate;
      } else {
        return null;
      }
    },
    getDynamicChangeDate(name, data) {
      if (data) {
        data.forEach((item, i) => {
          if (item.date)
            this.dynamicDateChange[name][i] = this.changeDate(item.date);
        });
      }
    },
    getRF12(id) {
      this.isLoading = true;
      this.$store
        .dispatch("FormRF/getRF12", id)
        .then((res) => {
          console.log("res", res);
          if (res !== "don't have research amendment yet") {
            this.form.instituteBook = res.instituteBook;
            this.status = res.status;
            this.form.noteDetail = res.noteDetail;
            this.form.researcherReportDate = res.noteDetailDate;
            this.researcherReportDate = this.changeDate(res.noteDetailDate);
            this.form.researchCode = res.researchCode;
            this.form.firstName = res.firstName;
            this.form.lastName = res.lastName;
            this.form.researchName = res.researchName;
            this.form.hasScreening = res.hasScreening.toString();
            this.form.screening = res.screening ? res.screening : "";
            this.form.hasAdjustMethod = res.hasAdjustMethod.toString();
            this.form.adjustMethod = res.adjustMethod ? res.adjustMethod : "";
            this.form.hasAddOperate = res.hasAddOperate.toString();
            this.form.addOperate = res.addOperate ? res.addOperate : "";
            this.form.hasExpandTime = res.hasExpandTime.toString();
            this.form.expandTime = res.expandTime ? res.expandTime : "";
            this.form.hasAdjustOtherMethod =
              res.hasAdjustOtherMethod.toString();
            this.form.adjustOtherMethod = res.adjustOtherMethod
              ? res.adjustOtherMethod
              : "";
            this.form.fileInformationSheet = res.fileInformationSheet
              ? res.fileInformationSheet
              : "";
            this.fileInformationSheetPath = res.fileInformationSheetPath
              ? res.fileInformationSheetPath
              : "";
            this.form.fileProtocolModify = res.fileProtocolModify
              ? res.fileProtocolModify
              : "";
            this.fileProtocolModifyPath = res.fileProtocolModifyPath
              ? res.fileProtocolModifyPath
              : "";
            this.form.fileInvestigator = res.fileInvestigator
              ? res.fileInvestigator
              : "";
            this.fileInvestigatorPath = res.fileInvestigatorPath
              ? res.fileInvestigatorPath
              : "";

            this.form.inclusion = res.inclusion == 1;
            this.form.procedureChange = res.procedureChange == 1;
            this.form.editorial = res.editorial == 1;
            this.form.hasOtherChange = res.hasOtherChange == 1;
            this.form.otherChange = res.otherChange;
            this.form.hasNewInformation = res.hasNewInformation == 1;
            this.form.hasAdvertisement = res.hasAdvertisement == 1;
            this.form.hasChangeInTitle = res.hasChangeInTitle == 1;
            this.form.changeInTitle = res.changeInTitle
              ? res.changeInTitle
              : "";
            this.form.fileOther = res.fileOther ? res.fileOther : "";
            this.form.hasChangeInInvestigator =
              res.hasChangeInInvestigator == 1;
            this.form.changeInInvestigatorAdd = res.changeInInvestigatorAdd;
            this.form.changeInInvestigatorDelete =
              res.changeInInvestigatorDelete
                ? res.changeInInvestigatorDelete
                : "";
            this.form.hasChangeInSponsor = res.hasChangeInSponsor == 1;
            this.form.changeInSponsorAdd = res.changeInSponsorAdd
              ? res.changeInSponsorAdd
              : "";
            this.form.changeInSponsorDelete = res.changeInSponsorDelete
              ? res.changeInSponsorDelete
              : "";
            this.form.signature = res.signature ? res.signature : "";
            this.form.date = res.date ? res.date : "";
            this.date = !res.date ? "" : this.changeDate(res.date);
            this.form.researchName2 = res.researchName2;
            this.form.researcher = res.researcher;
            this.form.phoneNumber = res.phoneNumber;
            this.form.affiliation = res.affiliation;
            this.agencyBookLink = res.agencyBookPath;
            this.agencyBook = res.agencyBook;
            this.form.bookNumber = res.bookNumber;
            this.form.bookDate = !res.bookDate
              ? ""
              : this.changeDate(res.bookDate);
            this.form.researcherSignature = res.researcherSignature;

            this.getDynamicChangeDate(
              "fileInformationSheet",
              res.fileInformationSheet
            );
            this.getDynamicChangeDate(
              "fileProtocolModify",
              res.fileProtocolModify
            );
            this.getDynamicChangeDate("fileInvestigator", res.fileInvestigator);
            this.getDynamicChangeDate("fileOther", res.fileOther);
            console.log("check error", res.reportDate);

            this.form.reportDate = !res.reportDate
              ? ""
              : this.changeDate(res.reportDate);
            if (res.research_amendment_edit) {
              res.research_amendment_edit.forEach((data) => {
                this.itemTableEdit.push({
                  version: data.version,
                  pageAndLine: data.pageAndLine,
                  suggestion: data.suggestion,
                  file: data.file,
                });
              });
            }
            // if (res.research_amendment_information) {
            //     let researchInformation = res.research_amendment_edit;
            //     res.research_amendment_information.forEach((data) => {
            //         this.itemResearchAll.push({
            //             version: data.version,
            //             pageAndLine: data.pageAndLine,
            //             suggestion: data.suggestion,
            //             file: data.file
            //         });
            //     });
            // }
            console.log("itemtable", this.itemTableEdit);
            this.isLoading = false;
          }
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
label.v-label.theme--light {
  color: #544a44;
}

.color-label-checkbox {
  label.v-label.theme--light {
    color: #3e7662;
  }
}

.linkPDF:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
